export class ScenarioConfig {
  // static readonly scenarioColors = ['#5b78b4', '#816c9c', '#5b8792', '#648f68', '#868960', '#8f735d', '#97667e'];
  static readonly scenarioColors = ['#5782D6', '#A47FD5', '#7FC4D5', '#7FD588', '#CFD57F', '#CFD57F', '#D57FA9'];
}
